import { Button, Text } from '@ksyos/design-system';
import type { IInsurer } from '../interfaces/insurer';
import { Figure } from './figure/Figure';
import { Modal } from './modals/Modal';

interface IInsurerCeilingModalProps {
    insurer: IInsurer;
    isOpen: boolean;
    onClose: () => void;
}

export function InsurerCeilingModal(props: IInsurerCeilingModalProps) {
    return (
        <Modal
            actionButtons={[<Button onClick={props.onClose}>Sluiten</Button>]}
            isOpen={props.isOpen}
            onClose={props.onClose}
            size="medium"
            title={`Zorgplafond ${props.insurer.name} bereikt`}
        >
            <Text mb={4}>
                Deze patiënt is verzekerd bij {props.insurer.name}. Ksyos heeft haar zorgkostenplafond van{' '}
                {props.insurer.name} bereikt. We vinden het erg vervelend en doen ons uiterste best om deze
                zorgverzekeraar ervan te overtuigen ons zorgplafond te verhogen. Tot die tijd kunnen wij helaas geen
                zorg leveren aan patiënten verzekerd bij {props.insurer.name}.
                <br />
                <br />
                Wil je hulp bij het vinden van een goed alternatief? Bel dan {props.insurer.name} om te zien waar wel
                zorg geleverd kan worden.
                {props.insurer.phoneNumberCareMediation && (
                    <>
                        <br />
                        <br />
                        <b>Zorgbemiddeling: {props.insurer.phoneNumberCareMediation}</b>
                    </>
                )}
            </Text>
            <Figure
                alt="helpdesk"
                centered={true}
                imageUrl={'/assets/images/helpdesk.svg'}
            />
        </Modal>
    );
}
